import React, { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { FormInput } from '../../components/FormInput';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SystemLoading, checkLoading } from '../../store/loadingStore';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { ReactComponent as TpiLogo } from "../../assets/images/logo/logo-tpi.svg";
import { checkRespSuccess, Base64Encoder, checkDpSuccess, decodeJWT, setHyperLinkAuth, setTokenInfo, writeAcConf, writeRoleFuncCodeList, writeToken, Base64Decoder, handleSessionClear, loginClientId } from '../../utility/service/tool-service';
import { AlertService, AlertType } from '../../utility/service/alert-service';
import { auth2 } from '../../utility/service/token-Service';
import LoginCommonOutline from './LoginCommonOutline';
import { environment } from "../../utility/environment";
import { dataEncryption, gtwidp_approve, gtwidp_authorization, gtwidp_login, gtwidp_login_credential, jweEncryption } from '../../utility/service/dgr-service';
import CompanyRoleSelector from "../../components/layout/CompanyRoleSelector";
import cryptoJS from 'crypto-js';
import GoogleCaptchaV3 from '../../components/GoogleCaptchaV3';
import { getRecaptchaSiteverify } from '../../utility/service/register-service';
import { updateUserLoginRecord } from '../../utility/service/api-service';
import { getSupportedLanguage } from '../../utility/languageUtils';



        

const Login = () => {
  const [urlParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loginParams, setLoginParams] = useState(null);
  const [,loading] = useContext(SystemLoading);
  const location = useLocation();
  const [changeToManager,setChangeToManager] = useState(false);
  const [siteKey,setSiteKey]=useState('');
  const queryParams = new URLSearchParams(window.location.search);
  
  

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    clearErrors,
    formState: { errors }
  } = useForm({
    defaultValues: {
      userName: '',
      password: ''
    },
    //錯誤驗證時機
    mode: 'onTouched'
  });


  const handleReCAPTCHA = async () => { //v3
    checkLoading(loading);
    if (window.grecaptcha) {
      try {
      // 請求 reCAPTCHA token
      const gTken = await window.grecaptcha.execute(siteKey, {
        action: "submit",
      });

      getRecaptchaSiteverify(gTken)
      .then((res)=>{          
        if(checkDpSuccess(res)){
          let success = res?.data?.RespBody?.success;
          if(success){
            handleLogin();
          }
        }else{
          checkLoading(loading,false);
        }
        
      })

      } catch (error) {
        // siteKey Mapping錯誤
        sessionStorage?.setItem("countError",0);
        handleLogin();
        checkLoading(loading,false);
      }
    } else {
      // Google reCAPTCHA 尚未載入！
      sessionStorage?.setItem("countError",0);
      handleLogin();
      checkLoading(loading,false);
    }
  };

  useEffect(() => {
    // 使用共用的語言對應邏輯
    i18n.changeLanguage(getSupportedLanguage());
  }, [i18n])

  // // 轉導至此頁時含錯誤碼rtn_code則彈窗提示，按下ok後轉導回首頁
  useEffect(() => {
    if(urlParams?.get('rtn_code')){
      if(urlParams.get('msg')) AlertService.logout(urlParams.get('rtn_code'),Base64Decoder(urlParams.get('msg')),AlertType.warning,null,`/${environment.contextPath}/${environment.contextVersion}/${environment.front}`);
    }
  },[urlParams])

  useEffect(()=>{
    if(searchParams.get('re')!==null){
      AlertService.ask({
        title: Base64Decoder(searchParams.get('re')),
        text: '',
        type: AlertType.warning,
        showCancelButton: false,
        confirmButtonText: t('button.confirm'),
        preConfirm: () => { 
          navigate(location.pathname, { replace: true });
          handleSessionClear();
         }
      });
      navigate(location.pathname, { replace: true });//轉頁將url的re參數移除
      handleSessionClear();//不要將loadTheme刪除 系統設定的主題色
    }
  },[searchParams.get('re')])

  useEffect(() => {    
    procLogin();
    if(urlParams?.get("username")){
      setValue("userName",Base64Decoder(urlParams?.get("username")));
      let pwd = urlParams?.get("sec");
      let str = '*';
      const arr = Array.from({ length: pwd }, (_, index) => '*');
      str = arr.join('');
      setValue("password",str)
    }
  }, [urlParams?.get("code"), urlParams?.get("state")])

  // 登入流程 如果params含有 code, state
  const procLogin = () => {
    if (urlParams.get("code") && urlParams.get("state")) {
      checkLoading(loading)
      // handleSessionClear();//不要將loadTheme刪除 系統設定的主題色
      let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';

      const clientSecret =''// res.data.RespBody.clientSecret;
      const redirect_uri =
        window.location.origin + window.location.pathname;

      const codeVerifier = sessionStorage.getItem("code_verifier");
      sessionStorage.removeItem("code_verifier");
      auth2(loginClientId(themeColorSession), urlParams.get("code"), redirect_uri, codeVerifier)
        .then((res) => {
          if (res && res?.data?.access_token) {
            setTokenInfo(res.data);
            writeToken('access_token', res.data.access_token)
            writeToken('decode_token', JSON.stringify(decodeJWT(res.data.id_token)));//這裡改接id_token 原本是 access_token
            return updateUserLoginRecord({eventType:"LOGIN"}); //Login Record
          }
        })
        .finally(() => {
          navigate("/management");
          sessionStorage.removeItem("countError");//登入成功將錯誤次數刪除
          checkLoading(loading,false);
        });
    }else{
      handleSessionClear();//不要將loadTheme刪除 系統設定的主題色
      
    }
  }

  const handleRedirect = (href) => {    
    const urlString = href;
    
    // 使用 URL 來解析這個 URL 字串
    const url = new URL(urlString);
    
    // 使用 URLSearchParams 來解析查詢參數
    const params = new URLSearchParams(url.search);
    
    // 獲取查詢參數 'code' 和 'state'
    const code = params.get('code');
    const state = params.get('state');

    // console.log(`${window.location.pathname}?code=${code}&state=${state}`);
    
    
    // 使用 navigate 進行跳轉，並附帶查詢參數
    // navigate(`/?code=${code}&state=${state}`, { replace: true });
    navigate(`/?${params.toString()}`, { replace: true });
    checkLoading(loading,false);

  
  };


  const apiConfirmLogin = (urlLogin) => {
    // gtwidp_approve(
    //   urlLogin.get("username"),
    //   urlLogin.get("redirect_uri"),
    //   urlLogin.get("state"),
    //   []
    // ).then((res) => {
    //   let url = new URL(res.request.responseURL);
    //   // window.location.href = url+=`&username=${Base64Encoder(getValues("userName"))}&sec=${getValues("password")?.length}`; //導轉
    //   window.location.href=url.href; 
    // });

    setLoginParams((pre) => {
      gtwidp_approve(
        pre.get("username"),
        pre.get("redirect_uri"),
        pre.get("state"),
        []
      ).then((res) => {        
        let url = new URL(res.request.responseURL);      
        handleRedirect(url.href);  
        //  window.location.href = url.href+=`&username=${Base64Encoder(getValues("userName"))}&sec=${getValues("password")?.length}`; //導轉
        // window.location.href=url.href;  
           
      });
      return { ...pre };
    });
  }

  const checkKeyDown = (e) => {
    // if (e.key === 'Enter') e.preventDefault();
    if (e.keyCode === 13) {
      e.stopPropagation();
    }
  };

  const generate_code_challenge = (code_verifier)=>{ 
    const code_verifier_sha = cryptoJS.SHA256(code_verifier);
    const code_verifier_b64 = cryptoJS.enc.Base64url.stringify(code_verifier_sha);
    return code_verifier_b64;
  }

  const handleLogin = () => {
    checkLoading(loading);
    // PKCE登入
    const code_verifier_ori = crypto.randomUUID();
    const code_verifier = code_verifier_ori+code_verifier_ori;
    // const code_verifier = 'B7gB0cY1C58ecNJ2J-231Ep-NmXgghAzgZg9nXu-vDo';
    const code_challenge = generate_code_challenge(code_verifier);
    // const code_challenge = 'Jhlf18b9aDFC5hkgQy3_MO1MznyS7kqMi32wELbhdos';
    sessionStorage.setItem("code_verifier",code_verifier);


    let ciphertext = "";
    jweEncryption(getValues("userName"),getValues("password"))
      .then((res) => {
        if (checkRespSuccess(res)) {
          ciphertext = res.data.RespBody.ciphertext;
        }
        let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
        let authorizationURL = `&scope=openid+profile+email&response_type=code`
        authorizationURL += `&state=${crypto.randomUUID()}`
        authorizationURL += `&redirect_uri=${window.location.protocol}//${window.location.hostname}${window.location.port===''?'':`:${window.location.port}`}/website/esg/ui`        
        authorizationURL += `&client_id=${loginClientId(themeColorSession)}`
        authorizationURL += `&code_challenge=${code_challenge}`
        authorizationURL += `&code_challenge_method=S256`
        // console.log("authorizationURL",authorizationURL);
        return gtwidp_login_credential(ciphertext, authorizationURL);
      })
      .then((res) => {
          let url = new URL(res?.request?.responseURL);
          const urlLogin = new URLSearchParams(url?.search);
          setLoginParams(urlLogin);

          if(res?.request?.responseURL){ 
            if (urlLogin.has("rtn_code") && urlLogin.get("rtn_code") === "error") {
              let rtnMsg = Base64Decoder(urlLogin.get("msg"));//解析回傳錯誤訊息
              let statusCode = '';
              let match = rtnMsg.match(/HTTP Status Code '(\d+)'/);
              if(match){
                statusCode = match[1]; //status Code 中的數字
                   AlertService.ok(
                    urlLogin.get("rtn_code"),
                    t(statusCode));
              }else{
                AlertService.ok(
                  urlLogin.get("rtn_code"),
                  Base64Decoder(urlLogin.get("msg")));
              }
              let errorNum =  sessionStorage?.getItem("countError");
              
              if(errorNum===undefined || errorNum===null){
                errorNum = 1; 
                sessionStorage?.setItem("countError",errorNum);
              }else{
                errorNum = parseInt(errorNum)
                errorNum+=1;
                sessionStorage?.setItem("countError",errorNum);
              }
              checkLoading(loading,false)
            }
            else{
              apiConfirmLogin(urlLogin);
              sessionStorage.removeItem("countError");//登入成功將錯誤次數刪除
            }
  
          }
      })
      .catch((error)=>{
        AlertService.ok(error?.response?.data?.status,error?.response?.data?.message);
      })
      .then((res) => {
      
      })
      .catch((error)=>{
        // 處理 gtwidp_login 發生的錯誤
        checkLoading(loading,false)
        AlertService.ok(error?.response?.data?.status,error?.response?.data?.message);
      })
      .finally(()=> {
        // checkLoading(loading,false)
      });

  };

  const onSubmit = async (data) => {
    // console.log(data);
    let errorNum = sessionStorage?.getItem("countError")===undefined || sessionStorage?.getItem("countError")===null?0:sessionStorage?.getItem("countError")
    if(errorNum > 0){ //有機器人驗證
      handleReCAPTCHA();
    }else{ //無機器人驗證
      handleLogin();
    }
  }

  const goLdapPage = (path) => {
    navigate(path);
  }

  const handleLoginConfirm = (type,clientId) => {
    let redirectUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port===''?'':`:${window.location.port}`}/website/esg/ui`
    // PKCE登入
    const code_verifier_ori = crypto.randomUUID();
    const code_verifier = code_verifier_ori+code_verifier_ori;
    // const code_verifier = 'B7gB0cY1C58ecNJ2J-231Ep-NmXgghAzgZg9nXu-vDo';
    const code_challenge = generate_code_challenge(code_verifier);
    // const code_challenge = 'Jhlf18b9aDFC5hkgQy3_MO1MznyS7kqMi32wELbhdos';
    sessionStorage.setItem("code_verifier",code_verifier);
    let state = crypto.randomUUID();
    let scope = "openid profile email"

    gtwidp_authorization(redirectUrl,state,scope,type,code_challenge,clientId)
  }

  const ssologin = (type = "GOOGLE") => {
    window.location.href = `${window.location.protocol}//${window.location.hostname}${window.location.port===''?'':`:${window.location.port}`}/website/esg/ssotoken/acidp/${type}/acIdPAuth`
  }

  const onRoleChange = (newColor, hasChanged)=>{
    if(hasChanged){
      setValue("userName","");
      setValue("password","");
      clearErrors();
    }
  }

  return (
    // {searchParams.get('re') !== null ? t('sys_logout') : t('login')} token過期不
      <LoginCommonOutline
      pageTitle={t('login')}>
      <CompanyRoleSelector onRoleChange={onRoleChange} changeToManager={changeToManager} />
      <form className='grid' onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
        <div className='col-12'>
          <FormInput
            labelClass="required"
            withLabel={true}
            register={register}
            errors={errors}
            id="userName"
            labelText={t("account")}
            type="text"
            rules={{ required: t('user_name_required') }}
            placeholder={t("account")}
          />
        </div>
        <div className='col-12'>
          <FormInput
            labelClass="required"
            withLabel={true}
            register={register}
            errors={errors}
            id="password"
            labelText={t("password")}
            type="password"
            placeholder={t("password")}
            rules={{ required: t('password_required') }}
          />
        </div>
        <div className="col-12">
          <Link underline="hover" color="inherit" to="/forgetaccpwd">{t('forget_acc_pwd')}?</Link>
        </div>

        <div className='col-12'>
          <Button type="submit" className='w-full mb-2' label={t("login")} rounded />

          { sessionStorage?.getItem("countError")===undefined?0:sessionStorage?.getItem("countError") > 0 && <GoogleCaptchaV3 setSiteKey={setSiteKey} siteKey={siteKey}></GoogleCaptchaV3> } 
         

        
        </div>
        <div className="col-12 other-login-btn">
            <Button disabled={sessionStorage?.getItem("loadTheme")==='mint'} className="p-button-icon-only" icon='pi pi-google' onClick={(e) => { 
              e.preventDefault(); 
              handleLoginConfirm("GOOGLE");
              }} size="small" rounded outlined />
            {
              queryParams?.get("corpCode") && queryParams?.get("corpCode")==='TPI' && (
                <Button  className="p-button-icon-only" style={{padding: '0.6rem'}} size="small" rounded outlined  onClick={(e)=>{setChangeToManager(true); e.preventDefault(); 
                  handleLoginConfirm("GOOGLE","EsgManager");}}>
                  <TpiLogo />
                </Button>
              )
            }
          
            {/* <Button className="p-button-icon-only" icon='pi pi-microsoft' onClick={(e) => { e.preventDefault(); ssologin("MS") }} size="small" rounded outlined /> */}
            {/* <Button onClick={() => {  handleLoginConfirm("LDAP"); }} size="small" label="LDAP" rounded outlined /> */}
            {/* <Button onClick={() => { goLdapPage("/ldap") }} size="small" label="MLDAP" rounded outlined /> */}
            {/* <Button onClick={() => { handleLoginConfirm("jdbc") }} size="small" label="JDBC" rounded outlined /> */}
        </div>
        
        {
          sessionStorage?.getItem("loadTheme")!=='mint' && (
            <div className='col-12'>
              <a onClick={() => { 
                if(sessionStorage?.getItem("loadTheme")==='mint'){ //管理者身分不能點註冊 返回不跳頁
                  return
                }else{
                  navigate('/register/JDBC');handleSessionClear();
                }
                 }} className="mobile-link">{t('join_us')}</a>
            </div>
          )
        }
       
       
      </form>

    </LoginCommonOutline>
   
    
  )
}

export default Login;